var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-hub"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 13.9705 13.9705 18 9 18C4.02943 18 0 13.9705 0 9C0 4.02943 4.02943 0 9 0C13.9705 0 18 4.02943 18 9ZM9.32256 6.6442C8.44713 7.0083 6.6976 7.76187 4.07392 8.90496C3.64787 9.07443 3.42469 9.24012 3.40438 9.40221C3.37004 9.67608 3.71303 9.78399 4.1801 9.93087C4.24363 9.95085 4.30947 9.97155 4.37695 9.99342C4.83647 10.1428 5.45462 10.3176 5.77597 10.3245C6.06746 10.3308 6.3928 10.2107 6.75198 9.96399C9.2034 8.30925 10.4688 7.47288 10.5483 7.45479C10.6042 7.4421 10.6819 7.42608 10.7346 7.47288C10.7872 7.51968 10.782 7.60824 10.7764 7.632C10.7425 7.7769 9.39609 9.02862 8.69931 9.67635C8.48214 9.87831 8.32806 10.0215 8.29656 10.0543C8.226 10.1275 8.15409 10.1968 8.08497 10.2634C7.6581 10.675 7.33797 10.9836 8.1027 11.4876C8.47026 11.7298 8.76429 11.93 9.05769 12.1298C9.37809 12.3481 9.69768 12.5657 10.1112 12.8368C10.2165 12.9058 10.3172 12.9776 10.4152 13.0474C10.788 13.3133 11.1231 13.552 11.5369 13.5139C11.7774 13.4918 12.0259 13.2657 12.152 12.5913C12.4501 10.9974 13.0362 7.5438 13.1717 6.12073C13.1836 5.99604 13.1686 5.83648 13.1566 5.76644C13.1446 5.69638 13.1196 5.59658 13.0285 5.5227C12.9207 5.4352 12.7543 5.41675 12.6797 5.41806C12.3412 5.42403 11.8219 5.60461 9.32256 6.6442Z",
    fill: "#767A7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTg);
export default __webpack_public_path__ + "static/media/icn_tg.b05c403b765603e83c8a8dd74048aac5.svg";
export { ForwardRef as ReactComponent };